import { kml as KmlParser } from "@tmcw/togeojson";
import WktParser from "wellknown";
import shp from "shpjs";

function parse(file, file_type, onSuccessCB, onErrorCB) {
  const asText = file_type !== "zip";

  let fileReader = new FileReader();
  fileReader.onload = async (e) => {
    let result = e.target.result;
    try {
      if (file_type === "kml") {
        result = KmlParser(new DOMParser().parseFromString(result, "text/xml"));
      } else if (file_type === "wkt") {
        result = WktParser(result);
      } else if (file_type === "zip") {
        const fc = await shp.parseZip(result); //returns feature collection array
        console.log("parsing zip result: ", fc);
        if (fc.constructor.name === "Object") {
          console.log('shape file parse shape is object')
          result = fc
        } else {
          console.log('shape file parse shape is array')
          result = fc.at(0);//TODO: think about the best way to select 2 areas if available 
        }
      } else {
        result = JSON.parse(result);
      }
      if (!result || result?.features?.length === 0) {
        onErrorCB();
        return;
      }
      onSuccessCB(result);
    } catch (err) {
      console.log("file parsing error", err);
      onErrorCB();
    }
  };
  if (asText) {
    fileReader.readAsText(file);
  } else {
    fileReader.readAsArrayBuffer(file);
  }
}

export default parse;
